export const UsersDetailsSkeletons = ({ rows = 6 }: { rows?: number }) => (
  <div className="p-5 rounded-xl bg-[#FFEFE5] border border-[#F8D2BF] animate-pulse">
    {/* Heading skeleton */}
    <div className="h-6 w-40 bg-gray-300 rounded mb-4"></div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {[...Array(rows)].map((_, i) => (
        <div key={i}>
          <div className="h-3 w-24 bg-gray-300 rounded mb-2"></div>
          <div className="h-4 w-full bg-gray-300 rounded"></div>
        </div>
      ))}
    </div>
  </div>
);
